<template>
  <div>
    <div
      class="bg-white w-full pt-6 px-4 sm:px-6 lg:px-8 border-b-4 border-primary pb-6"
    >
      <nav
        class="max-w-screen-xl mx-auto relative flex flex-col sm:flex-row items-center justify-between sm:h-10"
      >
        <div class="flex items-center flex-grow flex-shrink-0 lg:flex-grow-0">
          <div class="flex items-center justify-between w-full lg:w-auto">
            <img
              class="h-10 w-auto sm:h-12"
              src="../assets/img/logo.png"
              alt=""
            />
          </div>
        </div>
        <div class="lg:ml-10 lg:pr-4 mt-6 sm:mt-0">
          <a
            href="tel:5136552119"
            class="blue-g inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-full text-white focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150"
          >
            <svg
              class="-ml-1 mr-2 h-6 w-6 transform rotate-15"
              fill="currentColor"
              viewBox="0 0 22 22"
            >
              <path
                fill-rule="evenodd"
                d="M13.04 14.69l1.07-2.14a1 1 0 0 1 1.2-.5l6 2A1 1 0 0 1 22 15v5a2 2 0 0 1-2 2h-2A16 16 0 0 1 2 6V4c0-1.1.9-2 2-2h5a1 1 0 0 1 .95.68l2 6a1 1 0 0 1-.5 1.21L9.3 10.96a10.05 10.05 0 0 0 3.73 3.73zM8.28 4H4v2a14 14 0 0 0 14 14h2v-4.28l-4.5-1.5-1.12 2.26a1 1 0 0 1-1.3.46 12.04 12.04 0 0 1-6.02-6.01 1 1 0 0 1 .46-1.3l2.26-1.14L8.28 4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="font-bold text-lg">513-909-2894</span>
          </a>
        </div>
      </nav>
    </div>

    <div
      class="relative bg-white overflow-hidden border-t border-b border-indigo-t "
    >
      <div class="max-w-screen-xl mx-auto ">
        <div class="lg:hidden lg:inset-y-0 lg:right-0 lg:w-1/2">
          <img
            class="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full"
            src="../assets/img/CincinnatiFacade.jpg"
            alt=""
          />
        </div>

        <div class="relative z-10 pb-8 bg-white lg:max-w-2xl lg:w-full">
          <div class="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
            <div class="sm:text-center lg:text-left pt-4 lg:pt-12">
              <h2
                class="text-2xl leading-snug font-display font-bold sm:text-4xl sm:leading-none md:text-5xl"
              >
                Contactless

                <span class="text-primary whitespace-no-wrap"
                  >Self Storage</span
                >
              </h2>
              <p
                class="mt-3 text-lg text-default sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0 font-body opacity-80"
              >
                Has clutter taken over your home or office? Need to clear out
                space in your garage? With a variety of storage unit sizes
                perfect for family heirlooms, furniture, or even a boat or RV,
                Citadel Self Storage is sure to have the right fit for your
                needs.
                <span class="font-bold"
                  >We now offer contactless reservations and setup!</span
                >
              </p>
              <div class="mt-8 max-w-xs mx-auto lg:ml-0 lg:mr-0">
                <a
                  href="https://citadelselfstorage.com/cincinnati/units?utm_source=landing_page&utm_medium=website&utm_campaign=contactless"
                  class="w-full blue-g w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-full text-white focus:outline-none focus:shadow-outline transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
                >
                  View Units
                </a>
              </div>
            </div>
          </div>
          <svg
            class="hidden lg:block absolute right-0 inset-y-0 h-full w-48 transform translate-x-1/2 text-white"
            fill="currentColor"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <polygon points="50,0 100,0 50,100 0,100" />
          </svg>
        </div>
      </div>
      <div class="hidden md:absolute md:block lg:inset-y-0 lg:right-0 lg:w-1/2">
        <img
          class="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full"
          src="../assets/img/CincinnatiFacade.jpg"
          alt=""
        />
      </div>
    </div>

    <div class="py-16 bg-highlight overflow-hidden border-t border-secondary-b">
      <div
        class="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-screen-xl"
      >
        <svg
          class="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4"
          width="404"
          height="784"
          fill="none"
          viewBox="0 0 404 784"
        >
          <defs>
            <pattern
              id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
              x="0"
              y="0"
              width="20"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <rect
                x="0"
                y="0"
                width="4"
                height="4"
                class="text-gray-200"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width="404"
            height="784"
            fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"
          />
        </svg>

        <div class="relative lg:grid lg:grid-cols-2 lg:gap-24 lg:items-center">
          <div class="relative">
            <h4
              class="text-2xl leading-8 font-black tracking-tight sm:text-3xl lg:text-4xl sm:leading-9"
            >
              Contactless <span class="text-primary">Reservation Process</span>
            </h4>
            <p class="mt-3 text-lg leading-7 opacity-80">
              At Citadel Self Storage, we are committed to the health and safety
              of our customers and employees. As such, we have updated our
              process to reflect the current COVID-19 crisis:
            </p>

            <ul class="mt-10">
              <li>
                <div class="flex">
                  <div class="flex-shrink-0">
                    <div
                      class="flex items-center justify-center h-20 w-20 rounded-md bg-secondary text-white"
                    >
                      <img
                        src="../assets/img/reservation.svg"
                        alt="1. Online Unit Selection & Reservation"
                      />
                    </div>
                  </div>
                  <div class="ml-4">
                    <h5 class="font-extrabold text-lg leading-6">
                      1. Online Unit Selection &amp; Reservation
                    </h5>
                    <p class="mt-2 text-base leading-6 opacity-80">
                      Browse and select your unit online. You can also reserve
                      and pay for your unit online.
                    </p>
                  </div>
                </div>
              </li>
              <li class="mt-10">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <div
                      class="flex items-center justify-center h-20 w-20 rounded-md bg-secondary text-white"
                    >
                      <img
                        src="../assets/img/gate.svg"
                        alt="2. Unit is opened and prepared"
                      />
                    </div>
                  </div>
                  <div class="ml-4">
                    <h5 class="font-extrabold text-lg leading-6">
                      2. Unit is opened and prepared
                    </h5>
                    <p class="mt-2 text-base leading-6 opacity-80">
                      Once a unit is reserved, it is opened and a new lock is
                      placed inside.
                    </p>
                  </div>
                </div>
              </li>
              <li class="mt-10">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <div
                      class="flex items-center justify-center h-20 w-20 rounded-md bg-secondary text-white"
                    >
                      <img
                        src="../assets/img/code.svg"
                        alt="3. Gate access code"
                      />
                    </div>
                  </div>
                  <div class="ml-4">
                    <h5 class="font-extrabold text-lg leading-6">
                      3. Gate access code
                    </h5>
                    <p class="mt-2 text-base leading-6 opacity-80">
                      After a unit is prepared, a gate access code is sent. You
                      can then go to your new unit at your convenience!
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="mt-10 -mx-4 relative lg:mt-0 px-4">
            <svg
              class="hidden lg:absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden opacity-60"
              width="784"
              height="404"
              fill="none"
              viewBox="0 0 784 404"
            >
              <defs>
                <pattern
                  id="ca9667ae-9f92-4be7-abcb-9e3d727f2941"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    class="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="784"
                height="404"
                fill="url(#ca9667ae-9f92-4be7-abcb-9e3d727f2941)"
              />
            </svg>
            <div class="rounded-lg overflow-hidden shadow-lg">
              <img
                src="../assets/img/office.jpg"
                alt="Citadel Reception"
                class="rounded lg"
              />
            </div>
            <div class="mt-8 max-w-xs mx-auto">
              <a
                href="https://citadelselfstorage.com/cincinnati/units?utm_source=landing_page&utm_medium=website&utm_campaign=contactless"
                class="blue-g w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-full text-white focus:outline-none focus:shadow-outline transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
              >
                View Units
              </a>
            </div>
          </div>
        </div>

        <svg
          class="hidden lg:absolute right-full transform translate-x-1/2 translate-y-12 opacity-60"
          width="404"
          height="784"
          fill="none"
          viewBox="0 0 404 784"
        >
          <defs>
            <pattern
              id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
              x="0"
              y="0"
              width="20"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <rect
                x="0"
                y="0"
                width="4"
                height="4"
                class="text-gray-200"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width="404"
            height="784"
            fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
          />
        </svg>
      </div>
    </div>

    <div class="py-12 bg-white border-t border-secondary-b">
      <div
        class="mt-4 text-3xl md:text-5xl font-bold text-center px-4 leading-none"
      >
        Key Features
      </div>

      <div
        class="mt-12 max-w-xl mx-auto px-4 sm:px-6 lg:max-w-screen-xl lg:px-8"
      >
        <div
          class="lg:grid lg:grid-cols-3 lg:gap-8 py-8 pb-0 lg:pb-4 px-4 border border-b-0 border-secondary-b"
        >
          <div class="flex flex-col items-center justify-center">
            <div class="h-20 w-20 rounded-md bg-secondary text-white">
              <img
                src="../assets/img/temperature.svg"
                alt="Temperature Controlled Units Available"
              />
            </div>
            <div class="mt-5">
              <h5 class="text-lg leading-6 text-center opacity-80 font-bold">
                Temperature Controlled <br class="hidden sm:block" />
                Units Available
              </h5>
            </div>
          </div>
          <div class="mt-10 lg:mt-0 flex flex-col items-center justify-center">
            <div
              class="flex items-center justify-center h-20 w-20 rounded-md bg-secondary text-white"
            >
              <img
                src="../assets/img/loading.svg"
                alt="5 Different Covered Landing / Unloading Areas"
              />
            </div>
            <div class="mt-5">
              <h5 class="text-lg leading-6 text-center opacity-80 font-bold">
                5 Different Covered <br class="hidden sm:block" />Landing /
                Unloading Areas
              </h5>
            </div>
          </div>
          <div class="mt-10 lg:mt-0 flex flex-col items-center justify-center">
            <div
              class="flex items-center justify-center h-20 w-20 rounded-md bg-secondary text-white"
            >
              <img
                src="../assets/img/gated.svg"
                alt="Gated Access with Security Fence"
              />
            </div>
            <div class="mt-5">
              <h5 class="text-lg leading-6 text-center opacity-80 font-bold">
                Gated Access <br class="hidden sm:block" />with Security Fence
              </h5>
            </div>
          </div>
        </div>
        <div
          class="lg:grid lg:grid-cols-2 lg:gap-0 lg:px-40 pt-0 lg:pt-4 py-8 px-4 border border-t-0 border-secondary-b"
        >
          <div
            class="mt-0 pt-8 lg:pt-0 lg:mt-0 flex flex-col items-center justify-center"
          >
            <div
              class="flex items-center justify-center h-20 w-20 rounded-md bg-secondary text-white"
            >
              <img
                src="../assets/img/outdoor.svg"
                alt="Outdoor Drive-Up Storage"
              />
            </div>
            <div class="mt-5">
              <h5 class="text-lg leading-6 text-center opacity-80 font-bold">
                Outdoor <br class="hidden sm:block" />Drive-Up Storage
              </h5>
            </div>
          </div>
          <!-- <div class="mt-10 lg:mt-0 flex flex-col items-center justify-center">
            <div
              class="flex items-center justify-center h-20 w-20 rounded-md bg-secondary text-white"
            >
              <img src="../assets/img/rv.svg" alt="Covered RV/Boat Storage" />
            </div>
            <div class="mt-5">
              <h5 class="text-lg leading-6 text-center opacity-80 font-bold">
                Covered <br class="hidden sm:block" />RV/Boat Storage
              </h5>
            </div>
          </div> -->

          <div class="mt-10 lg:mt-0 flex flex-col items-center justify-center">
            <div
              class="flex items-center justify-center h-20 w-20 rounded-md bg-secondary text-white"
            >
              <img
                src="../assets/img/security.svg"
                alt="24 Hour Security Monitoring"
              />
            </div>
            <div class="mt-5">
              <h5 class="text-lg leading-6 text-center opacity-80 font-bold">
                24 Hour <br class="hidden sm:block" />Security Monitoring
              </h5>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-12 max-w-xs mx-auto">
        <a
          href="https://citadelselfstorage.com/cincinnati/units?utm_source=landing_page&utm_medium=website&utm_campaign=contactless"
          class="w-full blue-g w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-full text-white focus:outline-none focus:shadow-outline transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
        >
          View Units
        </a>
      </div>
    </div>

    <div
      class="mt-12 py-16 bg-highlight overflow-hidden border-t border-secondary-b"
    >
      <div
        class="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-screen-xl"
      >
        <div
          class="mt-4 text-3xl md:text-5xl font-bold text-center px-4 leading-none"
        >
          Unit Sizes Available
        </div>
        <div
          class="mt-12 grid gap-5 max-w-lg mx-auto sm:grid-cols-1 lg:grid-cols-3 lg:max-w-none"
        >
          <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
            <a
              href="https://www.citadelselfstorage.com/self-storage/oh/cincinnati/ridge-ave/#/units?category=Small"
            >
              <div class="flex-shrink-0">
                <img
                  class="h-64 w-full object-contain"
                  src="../assets/img/small.jpg"
                  alt="Small Unit"
                />
              </div>
              <div class="flex-1 bg-white flex flex-col justify-between">
                <div class="flex-1 bg-dark p-4">
                  <h4
                    class="text-white opacity-75 text-center text-xl font-bold"
                  >
                    Small (2.5"x5" &amp; up)
                  </h4>
                </div>
              </div>
            </a>
          </div>

          <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
            <a
              href="https://www.citadelselfstorage.com/self-storage/oh/cincinnati/ridge-ave/#/units?category=Medium"
            >
              <div class="flex-shrink-0">
                <img
                  class="h-64 w-full object-contain"
                  src="../assets/img/medium.jpg"
                  alt="Medium Unit"
                />
              </div>
              <div class="flex-1 bg-white flex flex-col justify-between">
                <div class="flex-1 bg-dark p-4">
                  <h4
                    class="text-white opacity-75 text-center text-xl font-bold"
                  >
                    Medium (7.5"x10" &amp; up)
                  </h4>
                </div>
              </div>
            </a>
          </div>

          <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
            <a
              href="https://www.citadelselfstorage.com/self-storage/oh/cincinnati/ridge-ave/#/units?category=Large"
            >
              <div class="flex-shrink-0">
                <img
                  class="h-64 w-full object-contain"
                  src="../assets/img/large.jpg"
                  alt="Large Unit"
                />
              </div>
              <div class="flex-1 bg-white flex flex-col justify-between">
                <div class="flex-1 bg-dark p-4">
                  <h4
                    class="text-white opacity-75 text-center text-xl font-bold"
                  >
                    Large (10"x20" &amp; up)
                  </h4>
                </div>
              </div>
            </a>
          </div>

          <!-- <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
            <a
              href="https://lexington.citadelselfstorage.com/units?filter=boat&utm_source=landing_page&utm_medium=website&utm_campaign=contactless"
            >
              <div class="flex-shrink-0">
                <img
                  class="h-64 w-full object-contain"
                  src="../assets/img/boats.jpg"
                  alt="RV / Boat Storage"
                />
              </div>
              <div class="flex-1 bg-white flex flex-col justify-between">
                <div class="flex-1 bg-dark p-4">
                  <h4
                    class="text-white opacity-75 text-center text-xl font-bold"
                  >
                    RV / Boat Storage
                  </h4>
                </div>
              </div>
            </a>
          </div> -->
        </div>

        <div class="mt-8 max-w-xs mx-auto">
          <a
            href="https://citadelselfstorage.com/cincinnati/units?utm_source=landing_page&utm_medium=website&utm_campaign=contactless"
            class="w-full blue-g w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium rounded-full text-white focus:outline-none focus:shadow-outline transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10"
          >
            View Units
          </a>
        </div>
      </div>
    </div>

    <div
      class="py-16 px-4 md:px-8 lg:px-16 bg-primary overflow-hidden border-t border-secondary-b"
    >
      <div
        class="grid md:grid-cols-3 gap-4 md:gap-8 lg:gap-24 max-w-screen-xl mx-auto text-center lg:text-left"
      >
        <div>
          <div class="grid grid-cols-2">
            <div>
              <p class="font-bold text-white">Citadel Self Storage</p>
              <p class="text-white">513-909-2894</p>
            </div>
            <div>
              <p class="font-bold text-white">5445 Ridge Ave</p>
              <p class="text-white">Cincinnati OH 45213</p>
            </div>
          </div>
          <div class="h-px mt-4 bg-highlight opacity-25"></div>
          <div class="mt-12 max-w-xs mx-auto">
            <a
              href="https://citadelselfstorage.com/cincinnati/units?utm_source=landing_page&utm_medium=website&utm_campaign=contactless"
              class="bg-white px-10 py-2 border border-transparent text-base leading-6 font-medium rounded-full text-primary focus:outline-none focus:shadow-outline transition duration-150 ease-in-out md:text-lg md:px-12"
            >
              View Units
            </a>
          </div>
        </div>
        <div>
          <p class="font-bold text-white">Office Hours:</p>
          <p class="text-white">
            Mon-Fri: 8:30a-7p<br />Sat: 9a-5p<br />Sun: 11a-5p
          </p>
        </div>
        <div class="text-center">
          <img
            class="h-32 mx-auto"
            src="../assets/img/footer-logo.svg"
            alt="Citadel Logo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["phone", "phoneLabel"],
};
</script>

<style lang="css">
#c-submit-button {
  background: rgb(235, 129, 48);
  background: linear-gradient(
    90deg,
    rgba(235, 129, 48, 1) 0%,
    rgba(235, 131, 47, 1) 50%,
    rgba(245, 179, 27, 1) 100%
  );
  color: white;
  font-size: 1.2rem;
  border-radius: 9999px;
  padding: 1rem 2rem;
  display: block;
  width: 90%;
  text-align: center;
  float: unset !important;
  margin: 0 auto;
}

.cognito input[type="text"],
.cognito .c-dropdown {
  border: 1px solid #a2b68a;
  border-radius: 5px;
  padding: 0.5rem 0.25rem;
}

.cognito .c-label label,
.cognito .c-label {
  font-weight: bold;
  font-size: 14px;
}

.cognito input[type="checkbox"],
.cognito input[type="radio"] {
  margin-right: 0.25rem;
  margin-top: -8px;
}

.cognito .c-forms-form .c-editor p {
  font-size: 10px;
  line-height: 1.1;
}
.cognito .c-title h3 {
  font-weight: bold;
}

.cognito .c-action {
  float: unset;
}
</style>
